export const TOKENS = {
  SessionProviderConfiguration: '@trustedshops/tswp-core-authorization:SessionProviderConfiguration',
  SessionInterceptor: '@trustedshops/tswp-core-authorization:SessionInterceptor',
  IdentityService: '@trustedshops/tswp-core-authorization:IdentityService',
  PermissionService: '@trustedshops/tswp-core-authorization:PermissionService',
  SessionProvider: '@trustedshops/tswp-core-authorization:SessionProvider',
  IdentityResolver: '@trustedshops/tswp-core-authorization:IdentityResolver',
  NgHttpInterceptor: '@trustedshops/tswp-core-authorization:NgHttpInterceptor'
};
